import { Capacitor } from '@capacitor/core'

import { useConfigStore } from '@/store/config'

import { CapgoUpdater } from './capgo'
import { GenericUpdater } from './generic'
import type { Updater } from './updater'

function getUpdater(): Updater {
  const platform = Capacitor.getPlatform()
  if (platform === 'android') {
    return new CapgoUpdater()
  }
  return new GenericUpdater()
}

class UpdaterEngine {
  private updater = getUpdater()
  private updateReady = false

  notifyAppReady() {
    this.updater.notifyAppReady()
  }

  async checkForUpdates() {
    const configStore = useConfigStore()
    const version = await this.updater.getVersion()
    const device = {
      id: configStore.device.id,
      platform: 'android',
      model: 'android-kds',
      os: 'android',
      osVersion: '1',
      appVersion: version.name,
      appBuild: version.build,
      webviewVersion: ''
    }
    const result = await this.updater.checkUpdates(device)
    if (result) {
      this.updateReady = true
    }
    return result
  }

  isUpdateReady() {
    return this.updateReady
  }

  async installUpdate() {
    await this.updater.installUpdate()
  }
}

export default new UpdaterEngine()
